var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "situation-warp",
      class: { show: _vm.congestDataList.length },
    },
    [
      _c(
        "van-row",
        {
          staticStyle: { "align-items": "center" },
          attrs: { type: "flex", justify: "space-between", gutter: "16" },
        },
        [
          _c("van-col", { staticClass: "situation-warp-title" }, [
            _vm._v("拥堵实况"),
          ]),
          _vm._v(" "),
          _vm.updateTime
            ? _c("van-col", { staticClass: "situation-update-time" }, [
                _vm._v("\n      更新于"),
                _c("span", [_vm._v(_vm._s(_vm.time))]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMap
        ? _c(
            "van-row",
            { attrs: { type: "flex", justify: "space-between", gutter: "16" } },
            [
              _c(
                "div",
                { staticClass: "map-container" },
                [
                  _c(
                    "CardMap",
                    {
                      attrs: {
                        city: _vm.fitViewCity,
                        "fit-view-priority": _vm.fitViewPriority,
                      },
                    },
                    [
                      _c("CongestSmallMarkerLayer", {
                        attrs: {
                          list: _vm.congestDataList,
                          "auto-fit-view": _vm.FIT_VIEW_PRIORITY.FIRST_PANEL,
                        },
                      }),
                      _vm._v(" "),
                      _c("TrafficLayer"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "map-mask",
                    on: { click: _vm.goEarlyWarningLink },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.areaType === 0
        ? _c(
            "van-row",
            { staticClass: "situation-info", attrs: { type: "flex" } },
            [
              _c(
                "van-col",
                {
                  staticClass: "situation-info-idx",
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(4)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-num-Bd info-idx",
                      style: {
                        color:
                          _vm.congestStyle && _vm.congestStyle.length > 0
                            ? _vm.congestStyle[0].color
                            : "",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.congestIndex))]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont",
                        class: _vm.trendIcon ? _vm.trendIcon.iconClass : "",
                        style: {
                          color:
                            _vm.trendIcon && _vm.trendIcon.iconColor
                              ? _vm.trendIcon.iconColor
                              : "",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-idx-text" }, [
                    _vm._v("拥堵指数"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "situation-info-point",
                  on: {
                    click: function ($event) {
                      return _vm.goEarlyWarningLink()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-point" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.congestDataList.length || 0) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("异常堵点")]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.areaType === 1
        ? _c(
            "van-row",
            { staticClass: "situation-info", attrs: { type: "flex" } },
            [
              _c(
                "van-col",
                {
                  staticClass: "situation-info-mileage",
                  attrs: { span: "8" },
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(8)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-mileage" }, [
                    _c("span", [_vm._v(_vm._s(_vm.congestHighWayTotalLength))]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "iconfont",
                      class: _vm.MileageIcon ? _vm.MileageIcon.iconClass : "",
                      style: {
                        color:
                          _vm.MileageIcon && _vm.MileageIcon.iconColor
                            ? _vm.MileageIcon.iconColor
                            : "",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _vm._v("拥堵里程(" + _vm._s(_vm.disUnit) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "situation-info-station",
                  attrs: { span: "8" },
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(10)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-station" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.realTimeData.congestTollNum || 0) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("拥堵收费站")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "situation-info-wall",
                  attrs: { span: "8" },
                  on: {
                    click: function ($event) {
                      return _vm.goEarlyWarningLink()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-wall" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.congestDataList.length || 0) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("异常堵点")]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.areaType === 2
        ? _c(
            "van-row",
            { staticClass: "situation-info", attrs: { type: "flex" } },
            [
              _c(
                "van-col",
                {
                  staticClass: "situation-info-idx",
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(4)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-num-Bd info-idx",
                      style: {
                        color:
                          _vm.congestStyle && _vm.congestStyle.length > 0
                            ? _vm.congestStyle[0].color
                            : "",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.congestIndex))]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont",
                        class: _vm.trendIcon ? _vm.trendIcon.iconClass : "",
                        style: {
                          color:
                            _vm.trendIcon && _vm.trendIcon.iconColor
                              ? _vm.trendIcon.iconColor
                              : "",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-idx-text" }, [
                    _vm._v("拥堵指数"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "situation-info-point",
                  on: {
                    click: function ($event) {
                      return _vm.goEarlyWarningLink()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-point" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.congestDataList.length || 0) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("异常堵点")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass:
                    "situation-info-mileage situation-info-mileage-other",
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(8)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-mileage" }, [
                    _c("span", [_vm._v(_vm._s(_vm.congestHighWayTotalLength))]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "iconfont",
                      class: _vm.MileageIcon ? _vm.MileageIcon.iconClass : "",
                      style: {
                        color:
                          _vm.MileageIcon && _vm.MileageIcon.iconColor
                            ? _vm.MileageIcon.iconColor
                            : "",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _vm._v("拥堵里程(" + _vm._s(_vm.disUnit) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass:
                    "situation-info-station situation-info-station-other",
                  on: {
                    click: function ($event) {
                      return _vm.goSituationLink(10)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "font-num-Bd info-station" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.realTimeData.congestTollNum || 0) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("拥堵收费站")]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-row",
        { attrs: { type: "flex" } },
        _vm._l(_vm.congestionCards, function (item, i) {
          return _c(
            "van-col",
            {
              key: i,
              staticClass: "congestion-item",
              attrs: {
                span:
                  i === _vm.congestionCards.length - 1 &&
                  _vm.congestionCards.length % 2 === 1
                    ? 24
                    : 12,
              },
              on: {
                click: function ($event) {
                  return _vm.goSituationLink(item.linksType)
                },
              },
            },
            [_c("CongestionCard", { attrs: { "card-data": item } })],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }